<div *transloco="let t" class="loyalty-indicator-wrapper" [ngClass]="{isInCheckout: isInCheckout()}">
    <div class="loyalty-indicator-container" [ngClass]="{isInCheckout: isInCheckout()}" 
        [ngStyle]="{'padding-bottom': isInCheckout() && !membership() ? '0' : ''}"
    >
            @if(membership()){
                @if(stepRemainingPoints > 0){
                    <span class="loyalty-indicator-message">
                        {{t('modals.cart.loyalty_indicator.points_remaining', {points: stepRemainingPoints})}}
                    </span>
                } @else {
                    <span class="loyalty-indicator-message">
                        {{t('modals.cart.loyalty_indicator.points_earn', {points: order().loyaltyPoints})}}
                    </span>
                }
            } @else {
                <span class="loyalty-indicator-message">
                    <a class="loyalty-link" [aria-label]="t('modals.cart.loyalty_indicator.join_loyalty') + ' ' + loyaltyAriaAndText" [routerLink]="storeIdService.getRoutePathSegments(['loyalty'])" (click)="closeModal()">
                        {{t('modals.cart.loyalty_indicator.join_loyalty')}}
                    </a>
                    <span aria-hidden="true">{{loyaltyAriaAndText}}</span>
                </span>
            }
            @if(subscriptionPoints()){
                <span class="loyalty-indicator-message">
                    {{t('modals.cart.loyalty_indicator.subscription_points', {points: subscriptionPoints()})}}
                </span>
            }

    </div>
    @if(membership()){
        <div class="progressbar-container" [ngClass]="{isInCheckout: isInCheckout()}">
            <div class="progress-background"></div>
            <div class="progress" [style.width]="currentProgress + '%'"></div>
        </div>
    }
</div>
